import createCrud from '../crud';

export default createCrud({
    resource: 'approvals',
    parent: 'budget'
  });